module.exports = __webpack_public_path__ + "img/dynamic-prices.d1373742.png";